'use strict'

/**
 *
 * @name: storyUserBox
 *
 */

import _get from 'lodash.get'

import DirectiveTemplate from './nn-story-user-box.directive.html'
import './nn-story-user-box.directive.scss'

function StoryUserBoxDirective(transObject, $filter) {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      post: '='
    },
    link: function(scope, element) {

      /*
       *
       * @CONFIG
       *
       */


      const _matchContributorByType = $filter('matchContributorByType')
      const _allContributors = []

      scope.data = {}

      /*
       *
       * @PUBLIC
       *
       */


      /*
       *
       * @PRIVATE
       *
       */


      function _terminate() {
        scope.$destroy();
        element.remove();
      }


      function _initData () {
        const _contributors = _get(scope, 'post.contributors')

        if (!_contributors.length) {
          return _terminate()
        }

        _contributors.forEach(item => {
          _allContributors.push(transObject.trueSlug(item))
        })

        scope.data = [
          {
            title: 'CONTRIBUTORS',
            items: _matchContributorByType(_allContributors, ['contributor', 'brand'])
          },
          {
            title: 'EDITORS',
            items: _matchContributorByType(_allContributors, 'editor')
          }
        ]
      }


      /*
       *
       * @INIT
       *
       */



      _initData()

      scope.$watch('post.id', (newVal, oldVal) => {

        if (newVal === oldVal) {
          return
        }

        if (newVal) {
          _initData()
        }
      }, true)
    }
  }
}

export default StoryUserBoxDirective



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-story-user-box/nn-story-user-box.directive.js